<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-06-15 19:45:16
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-05 16:13:51
 * @FilePath: \seller.sviptrader.com\src\components\layout\components\funIntroduce\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<transition name="dialog-fade" v-if="visible">
		<div class="upgradation-box flex-row flex-align-center flex-just-center">
			<div class="content pos-rela">
				<div class="flex-center cursor-pointer" @click="bindShopSkip">
					<slot name="introductionImg"></slot>
				</div>
				<div class="close yx-color-text-placeholder hover cursor-pointer">
					<i class="el-icon-close" @click.stop="beforeClose"></i>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
import { getPopupAdOne } from '@/api/common';
import { mapState } from 'vuex';
export default {
	computed: {
		...mapState(['vuex_isshopurl']),
	},
	data() {
		return {
			visible: false,
		};
	},
	created() {
		if (this.vuex_isshopurl) this.getPopup();
	},
	methods: {
		async getPopup() {
			const data = await getPopupAdOne({ type: 'sample_cooperate_introduce1' });
			this.visible = data.is_pop || false;
		},
		beforeClose() {
			this.visible = false;
		},
		bindShopSkip() {
			let path = '/index/home';
			this.$auth.hasPermi('system:cooperativeShop-query') && (path = '/cooperativeShop/list');
			this.$auth.hasPermi('system:viewRules-query') && (path = '/cooperativeShop/collaborateRules/viewRules');
			const { href } = this.$router.resolve({ path });

			window.open(href, '_blank');
		},
	},
};
</script>
<style lang="less" scoped>
.upgradation-box {
	z-index: 3017;
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: rgba(29, 33, 41, 0.6);
	.content {
		width: 960px;
		margin: 0 auto;
		border-radius: 12px;
		::v-deep .el-carousel__item {
			display: flex;
			justify-content: center;
		}
		::v-deep .el-carousel__arrow {
			border: 1px solid #fff;
		}
		.close {
			position: absolute;
			display: inline-block;
			right: 24px;
			top: 24px;
		}
	}
}
</style>
